<template>
    <img class="xl:w-20 lg:w-20 md:w-14 sm:w-10 cursor-pointer border-4 p-1 rounded-lg" src="../assets/materials/speaker.png" alt="speaker" @click="playSoundHowTo()">
    <audio id="how_to" :src="pathSoundHowTo" :autoplay="autoplay" type="audio/mp4" />    
</template>

<script>
const path = '../assets/sound/';
const path_how_to = 'how_to/';

const soundHowTo = (checkpoint) => {                    
    return path + path_how_to + checkpoint + '_how_to_play.m4a';
};

export default {
    name: "Sound",
    props: {
        text: String,        
        checkpoint: String,
        autoplay: Boolean,
        soundType: String,
        answer: String,
        soundanswer: Function,
    },  
    data(){        
        return {
            disable: false,   
            // autoplay: false, 
            pathSoundHowTo: soundHowTo(this.checkpoint),
            pathSoundAnswer: ''
        };        
    },     
    methods: {
        setDisable() {
            this.disable = true           
        },
        playSoundHowTo() {        
            document.getElementById("how_to").pause();
            document.getElementById("how_to").play();
        },        
    }
};
</script>